<section class="content-container">
  <h2>Users</h2>
  <app-data-table [dataTable]="dataTable" dataTableKey="engage:users" [canClick]="false" />
</section>
